export { default as ResendOTP } from "./components/ResendOTP";
export { default } from "./components/OTPReader";
